import { render, staticRenderFns } from "./ShowObservations.vue?vue&type=template&id=7d4523b2&"
import script from "./ShowObservations.vue?vue&type=script&lang=js&"
export * from "./ShowObservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports